// Libs
import React, { useContext } from 'react';
// Config
import { ElementViewBuilderConfig } from 'core';
// Context
import { ElementViewBuilderContext } from 'core/context';
// Components
import { Wrapper } from 'components';
import Read from '../Read';
import { getDocNumberElementViewPayload } from './DocNumber.utils';
// Styles
import styles from './DocNumber.module.css';

const DocNumber = ({ rowData, field }) => {
	const { setElementView } = useContext(ElementViewBuilderContext);
	const elementViewKeys =
		ElementViewBuilderConfig.getAuthorizedElementViewKeys();

	const handleDocChange = () =>
		setElementView(
			getDocNumberElementViewPayload(
				rowData,
				elementViewKeys.TRANSACTION_ELEMENT,
			),
		);

	return (
		<Wrapper padding='0' width='100%' margin='0'>
			<Read
				hoverable
				className={styles.container}
				field={field}
				rowData={rowData}
				setOpen={handleDocChange}
			/>
		</Wrapper>
	);
};

export default DocNumber;
